export enum PeriodType {
    All = "ALL",
    Game = "GAME",
    Map = "MAP",
    FirstHalf = "FIRST_HALF",
    SecondHalf = "SECOND_HALF",
    Set = "SET",
    Period1 = "PERIOD_1",
    Period2 = "PERIOD_2",
    Period3 = "PERIOD_3",
    Quarter1 = "QUARTER_1",
    Quarter2 = "QUARTER_2",
    Quarter3 = "QUARTER_3",
    Quarter4 = "QUARTER_4",
    Leg = "LEG",
    CurrentRound = "CURRENT_ROUND",
}
